'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PropTypes = require('prop-types');
var React = require('react');
var ADAHelpers = require('../lib/ADAHelpers');
var _ = require('lodash');

module.exports = (_temp2 = _class = function (_React$Component) {
    _inherits(_class, _React$Component);

    function _class() {
        var _temp, _this, _ret;

        _classCallCheck(this, _class);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (e) {
            e.preventDefault();
            if (_this.props.handleClick) {
                _this.props.handleClick(e);
            }
        }, _this.accessibilityHelperHandler = function (e) {
            if (_this.props.accessibilityHelper) {
                _this.props.accessibilityHelper(e);
            } else {
                ADAHelpers.keyupHandler(e);
            }
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _class.prototype.render = function render() {
        var size = this.props.size ? this.props.size : 'large';
        var customIconClass = this.props.customIconClass ? this.props.customIconClass : '';
        var customClass = this.props.customClass ? this.props.customClass : '';
        var icon = this.props.icon ? React.createElement('span', { className: "glyphicon icon-button-glyph " + customIconClass + " glyphicon-" + this.props.icon, 'aria-hidden': 'true' }) : React.createElement('img', { src: this.props.image, role: 'icon', alt: this.props.iconAlt });

        //build attributes so empty attributes wont happen
        var attributes = { role: 'button' };
        if (this.props.id) {
            attributes.id = this.props.id;
        }
        _.assign(attributes, this.props.attributesForADA);

        return React.createElement(
            'button',
            _extends({ onKeyDown: this.accessibilityHelperHandler, onClick: this.handleClick, className: customClass + " icon-button icon-button-" + size }, attributes),
            icon,
            React.createElement(
                'span',
                { className: 'icon-text' },
                this.props.text
            )
        );
    };

    return _class;
}(React.Component), _class.propTypes = {
    size: PropTypes.string, //size of icon
    customIconClass: PropTypes.string, //custom class to apply to icon
    customClass: PropTypes.string, //custom class to apply to component
    icon: PropTypes.string, //glyphicon icon name (chose between image or icon)
    iconAlt: PropTypes.string, //alt text to use for icon
    image: PropTypes.string, //url to image if not using glyphicon
    id: PropTypes.string, //id to place on component if desired
    text: PropTypes.string, //text to include after the icon
    handleClick: PropTypes.func, //function iconbutton should trigger (returns event)
    accessibilityHelper: PropTypes.func, //if enter or space are not the desired click triggers
    attributesForADA: PropTypes.object // object of attributes and values regarding ada such as aria-label, role, aria-checked
}, _class.defaultProps = {
    iconAlt: ''
}, _temp2);


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/components/AdaIconButton.js
// module id = 314
// module chunks = 0